<template>
  <div class="container MarketingBrief">
    <div class="row text-light" style="text-align: center">
      <h1>What We offer For You!</h1>
      <hr>
    </div>
    <br>
    <div class="row">
      <div class="col-md-4 col-lg-4 col-sm-12"  data-aos="fade-up"
           data-aos-offset="200"
           data-aos-delay="50"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out"
           data-aos-mirror="true"
           data-aos-once="false">
        <b-card id="card1" text-variant="light" class="text-center draw" style="border-radius: 0 !important; height: 60vh !important;">
          <template #header>
            <h2 class="display-9 my-3 font-weight-bold"><b-icon class="animate1" icon="award"></b-icon></h2>
            <div class="dez-separator bg-primary"></div>
            <h4 class="mb-0 display-8 my-1 font-weight-bold">Safest & Easiest Way Around</h4>
          </template>

          <b-card-body>
<!--            <b-card-title>Card Title</b-card-title>-->
<!--            <b-card-sub-title class="mb-2">Card Sub Title</b-card-sub-title>-->
            <b-card-text>
              One tap and a car comes directly to you. Hop in—your driver knows exactly where to go. And when you get there, just step out. Payment is completely seamless.
            </b-card-text>
          </b-card-body>
        </b-card>
      </div>

      <div class="col-md-4 col-lg-4 col-sm-12"  data-aos="fade-down"
           data-aos-offset="200"
           data-aos-delay="50"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out"
           data-aos-mirror="true"
           data-aos-once="false">
        <b-card id="card2" text-variant="light" class="text-center draw" style="border-radius: 0 !important; height: 60vh !important;">
          <template #header>
            <h2 class="display-9 my-3 font-weight-bold"><b-icon class="animate2" icon="bag-check-fill"></b-icon></h2>
            <div class="dez-separator bg-primary"></div>
            <h4 class="mb-0 display-8 my-1 font-weight-bold">Get Anywhere, Anytime</h4>
          </template>

          <b-card-body>
<!--            <b-card-title>Card Title</b-card-title>-->
<!--            <b-card-sub-title class="mb-2">Card Sub Title</b-card-sub-title>-->
            <b-card-text>
              Daily commute. Errand across town. Early morning travel. Late night drinks. Wherever you're headed, count on NewTaxi for a ride—no reservations required.
            </b-card-text>
          </b-card-body>
        </b-card>
      </div>

      <div class="col-md-4 col-lg-4 col-sm-12"  data-aos="fade-up"
           data-aos-offset="200"
           data-aos-delay="50"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out"
           data-aos-mirror="true"
           data-aos-once="false">
        <b-card id="card3" text-variant="light" class="text-center draw" style="border-radius: 0 !important; height: 60vh !important;">
          <template #header>
            <h2 class="display-9 my-3 font-weight-bold"><b-icon class="animate3" icon="currency-exchange"></b-icon></h2>
            <div class="dez-separator bg-primary"></div>
            <h4 class="mb-0 display-8 my-1 font-weight-bold"><font-awesome-icon icon="fa-solid fa-circle-dollar-to-slot" />Low-cost to luxury</h4>
          </template>

          <b-card-body>
            <b-card-text>
              <font-awesome-icon icon="fa-solid fa-circle-dollar-to-slot" style="color:black !important;"/>
               Economy cars at everyday prices are always available. For special occasions, no occasion at all, or when you just a need a bit more room, call a black car or SUV.
            </b-card-text>
          </b-card-body>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MarketingBrief',
  props: {},
}
</script>

<style scoped>
.MarketingBrief{
  height: 90vh;
}
.animate1,.animate2,.animate3{
  position: relative;
  top: 0;
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
}
#card1:hover .animate1{    top: -10px;
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  }
#card2:hover .animate2{
  top: -10px;
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
}
#card3:hover .animate3{
  top: -10px;
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
}
.draw {
  background-color: #1E2C3844;
  border: 1px;
  box-sizing: border-box;
  box-shadow: inset 0 0 0 2px transparent;
  font-size: inherit;
  position: relative;
  vertical-align: middle;
  -webkit-transition: width 0.25s ease-out, height 0.25s ease-out 0.25s;
  transition: width 0.25s ease-out, height 0.25s ease-out 0.25s;
}
.draw > div {
  position: relative;
  z-index: 1;
}
.draw:before, .draw:after {
  box-sizing: inherit;
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
}

.draw {
  -webkit-transition: color 0.25s;
  transition: color 0.25s;
}
.draw:before, .draw:after {
  border: 2px solid transparent;
  width: 0;
  height: 0;
}
.draw:before {
  top: 0;
  left: 0;
}
.draw:after {
  bottom: 0;
  right: 0;
}
.draw:hover:before, .draw:hover:after {
  width: 100%;
  height: 100%;
}
.draw:hover:before {
  -webkit-transition: width 0.25s ease-out, height 0.25s ease-out 0.25s;
  transition: width 0.25s ease-out, height 0.25s ease-out 0.25s;
}
.draw:hover:before {
  border-top-color: rgb(255, 222, 32);
  border-right-color: rgb(255, 222, 32);
}
.draw:hover:after {
  -webkit-transition: border-color 0s ease-out 0.5s, width 0.25s ease-out 0.5s, height 0.25s ease-out 0.75s;
  transition: border-color 0s ease-out 0.5s, width 0.25s ease-out 0.5s, height 0.25s ease-out 0.75s;
}
.draw:hover:after {
  border-bottom-color: rgb(255, 222, 32);
  border-left-color: rgb(255, 222, 32);
}
.dez-separator {
  display: inline-block;
  height: 3px;
  width: 50px;
  margin-bottom: 10px;
  position: relative;
  /*-moz-transition: all 0.5s;*/
  /*-webkit-transition: all 0.5s;*/
  /*transition: all 0.5s;*/
}
.draw:hover .dez-separator {
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  width: 80px;
}
.dez-separator {
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
}
.bg-primary{
  background-color: #ffffff !important;
}
/*@media (prefers-reduced-motion: no-preference) {*/
/*  .square {*/
/*    animation-name: transation-up;*/
/*    animation-duration: 3s;*/
/*    animation-iteration-count: 3;*/
/*  }*/
/*}*/
</style>